import { render, staticRenderFns } from "./Paintings.vue?vue&type=template&id=3d944aee&"
import script from "./Paintings.vue?vue&type=script&lang=js&"
export * from "./Paintings.vue?vue&type=script&lang=js&"
import style0 from "./Paintings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports